import PictureRetina from '../picture-fill/picture-fill';
import Button from '../button/button';
import styles from './error-comp.module.scss';

type Props = {
  action: any;
  cta: string;
  image?: string | null | undefined;
  imageClassName?: string;
  subtitle?: string;
  title: string;
};

const ErrorComp = ({
  action,
  cta,
  image,
  imageClassName,
  subtitle = '',
  title,
}: Props) => (
  <div className={styles.container}>
    <PictureRetina
      className={imageClassName || 'image--error-comp'}
      url={image ? image : require('./assets/error.png')}
    />
    <h1 className={styles.headline}>{title}</h1>
    <div className={styles.subtitle}>{subtitle}</div>
    <div className={styles.button}>
      <Button dataHook='go_back' text={cta} onClick={action} />
    </div>
  </div>
);

export default ErrorComp;

ErrorComp.displayName = 'ErrorComp';
